if (!customElements.get('csc-popular-models')) {
  customElements.define('csc-popular-models', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.items = Array.from(this.querySelectorAll('.csc-models__item'));
      this.button = this.querySelector('.csc-models__toggle');
      this.media = window.matchMedia('(min-width: 750px)');
      this.expanded = false;
      this.update = () => {
        const limit = this.media.matches ? 6 : 4;
        this.items.forEach((item, index) => { item.hidden = !this.expanded && index >= limit; });
        this.button.hidden = this.items.length <= limit;
        this.toggleAttribute('data-collapsed', !this.expanded && this.items.length > limit);
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.setAttribute('aria-label', this.expanded ? 'Show fewer models' : 'Show more models');
        this.button.setAttribute('title', this.expanded ? 'Show fewer models' : 'Show more models');
      };
      this.toggle = () => { this.expanded = !this.expanded; this.update(); };
      this.button.addEventListener('click', this.toggle);
      this.media.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() {
      if (this.media && this.update) this.media.removeEventListener('change', this.update);
      if (this.button && this.toggle) this.button.removeEventListener('click', this.toggle);
      this.initialised = false;
    }
  });
}
